import { IActivityTrack, ISectionsStudyStatus, IBasicSubscription } from '@sdk/contracts';
import { Table } from 'antd';
import { TFunction } from 'i18next';
import { AlignType, FixedType } from 'rc-table/lib/interface';
import { useTranslation } from 'react-i18next';

import { AverageScore } from './AverageScore';
import { SectionStatus } from './SectionStatus';

import { ActivitiesTracking } from '@/components/ActivitiesTracking';
import { useIsMobile } from '@/hooks';
import { useMySubscriptions, useMySubscriptionStudyStatus } from '@/store';

export const SectionList = () => {
  const { t } = useTranslation('StudentCourseSummaryTranslations');

  const { selectedSubscription, isLoading: isLoadingSubscription } = useMySubscriptions();
  const { studyStatus, isLoading } = useMySubscriptionStudyStatus();
  const isMobile = useIsMobile('xs');

  if (!selectedSubscription) return null;
  const { activityTracking } = selectedSubscription;

  return (
    <Table
      rowKey="sectionId"
      tableLayout="fixed"
      columns={columns(t, activityTracking, selectedSubscription)}
      dataSource={studyStatus}
      pagination={false}
      scroll={{ x: isMobile ? window.innerWidth - 50 : undefined }}
      loading={isLoading || isLoadingSubscription}
    />
  );
};

const columns = (
  t: TFunction<'StudentCourseSummaryTranslations'>,
  track: IActivityTrack[],
  selectedSubscription: IBasicSubscription
) => [
  {
    title: t('SECTION'),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: 200,
    fixed: 'left' as FixedType
  },
  {
    title: t('STATUS'),
    dataIndex: '_id',
    key: '_id',
    width: 200,
    render: (_id: string, section: ISectionsStudyStatus) => (
      <SectionStatus section={section} selectedSubscription={selectedSubscription} />
    )
  },
  {
    title: t('PROGRESS'),
    dataIndex: '_id',
    key: '_id',
    width: 150,
    align: 'center' as AlignType,
    render: (_: string, section: ISectionsStudyStatus) => (
      <ActivitiesTracking section={section} tracking={track} />
    )
  },
  {
    title: t('SCORE'),
    dataIndex: 'avgScore',
    key: 'avgScore',
    width: 150,
    align: 'center' as AlignType,
    render: (avgScore: number) => <AverageScore averageScore={avgScore} />
  }
];
